import moment from 'moment';
import {validateDate} from 'shared/validators';
import {
  ERROR_UNTIL_REQUIRED,
  ERROR_UNTIL_BEFORE_START_DATE,
  ERROR_UNTIL_AFTER_END_DATE
} from './constants';

export const getRepeatingDays = (startDate, repeatOn = [], until) => {
  const untilEnd = moment(until).endOf('day');
  const start = moment(startDate);
  let latestWeekDate = moment();
  let next = start.clone();
  let addDays = 0;
  let dates = [];

  dates.push(start.format());

  while (until && next.isBefore(untilEnd)) {
    dates = dates.concat(getDaysOfWeek(next, repeatOn, untilEnd, start));
    latestWeekDate = getLatestWeekDate(dates);
    addDays = getAddDays(next, latestWeekDate);
    next.add(addDays, 'days');
  }

  return dates.filter((value, index, self) => self.indexOf(value) === index);
};

const getLatestWeekDate = (dates) => {
  const latestWeekDate = moment(dates[dates.length - 1]);

  return latestWeekDate;
};

const getAddDays = (next, latestWeekDate) => {
  const addDays = next.diff(latestWeekDate, 'days');

  return (Math.abs(addDays) + 1);
};

export const getAllDaysOfWeek = (startDate, repeatOn) => {
  const days = [];
  const start = moment(startDate);
  
  if (!repeatOn) return days;

  repeatOn.forEach((shouldRepeat, dayOfWeek) => {
    if (shouldRepeat) {
      const nextDay = getNextWeekday(start, dayOfWeek);

      days.push(nextDay.format());
    }
  });
  return days;

};

const getDaysOfWeek = (start, repeatOn, until, startDate) => {
  const days = [];

  repeatOn.forEach((shouldRepeat, dayOfWeek) => {
    if (shouldRepeat) {
      const nextDay = getNextWeekday(start, dayOfWeek);

      if (nextDay.isBefore(until) && nextDay.isAfter(startDate)) days.push(nextDay.format());
    }
  });
  return days;

};

const getNextWeekday = (start, day) => {
  const startDay = moment(start);
  const nextWeekday = startDay.day(day);

  return nextWeekday;
};

export const validateRepeatUntil = (data) => {
  if (data.repeatOn && data.repeatOn.some(x => !!x)) {
    if(!validateDate(data.until)) {
      return ERROR_UNTIL_REQUIRED;
    }
    if (data.until && moment(data.until).isBefore(data.startDateTime)) {
      return ERROR_UNTIL_BEFORE_START_DATE;
    }
    if (data.until && data.until > data.tournamentEndDate) {
      return ERROR_UNTIL_AFTER_END_DATE;
    }
  }
};

export const  validateSquad = (data) => {
  const errors = {};

  if (!data.eventId) {
    errors.eventId = 'An event type must be specified';
  } if (!data.time) {
    errors.time = 'Time is required';
  } if (!data.startLane) {
    errors.startLane = 'Start lane is required';
  } if (!data.endLane) {
    errors.endLane = 'End lane is required';
  }

  if (data.startLane % 2 === 0) {
    errors.startLane = 'Start lane must be an odd number.';
  } else if (data.origStartLane && data.startLane > data.origStartLane) {
    errors.startLane = 'Start lane must be less than or equal to its original value.';
  }

  if (data.endLane && data.endLane % 2 !== 0) {
    errors.endLane = 'End lane must be an even number.';
  } else if (data.endLane && data.origEndLane && data.endLane < data.origEndLane) {
    errors.endLane = 'End lane must be greater than or equal to its original value.';
  }

  if (+data.endLane < +data.startLane) {
    errors.endLane = 'End lane must be greater or equal to start lane.';
  }

  return errors;
};


// WEBPACK FOOTER //
// ./src/features/tournament/squads/utils.js